import * as React from "react"

export default function NotificationOutlineIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.334 11.334h1.333v1.333H1.333v-1.333h1.334V6.667a5.333 5.333 0 1110.666 0v4.667zm-1.334 0V6.667a4 4 0 00-8 0v4.667h8zM6 14h4v1.334H6V14z"
        fill={props.fill}
      />
    </svg>
  )
}
